import { makeStyles } from '@material-ui/core/styles';
import { ERebrandingFonts } from 'helpers/constants';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& label': {
      color: '#546E7A',
      fontSize: 16,
      fontWeight: 600,
      fontFamily: ERebrandingFonts.OPENSANS,
      height: 7,
      transform: 'translate(20px) scale(0.75) !important',
    },
    '& input, & > div > div': {
      color: '#546E7A',
      padding: '13px 14px',
      fontFamily: ERebrandingFonts.OPENSANS,
      backgroundColor: '#fff',
      fontSize: 14,
      paddingLeft: 20,
      '&::placeholder': {
        color: '#78909C',
      },
    },
    '& > div': {
      backgroundColor: '#fff',
    },
    '& fieldset': {
      borderColor: '#B0BEC5',
      '& legend': {
        marginLeft: 6,
        fontSize: 12.8,
      },
    },
  },
  defaultHelperText: {
    marginInline: 0,
    marginTop: theme.spacing(1),
    fontFamily: ERebrandingFonts.OPENSANS,
    fontSize: 10,
  },
  helperText: {
    color: '#072D83',
  },
  selectIcon: {
    top: '50%',
    transform: 'translateY(-50%)',
    position: 'absolute',
    right: '16px',
    pointerEvents: 'none',
    color: '#546E7A',
  },
  selectMenuPaper: {
    color: '#37474F',
    fontSize: 14,
    maxHeight: 'calc(100% - 500px)',
  },
  selectMenuList: {
    '& > li': {
      lineHeight: '14px',
      padding: `10px ${theme.spacing(2)}px`,
      fontFamily: ERebrandingFonts.OPENSANS,
      '&:hover': {
        backgroundColor: '#ECEFF1',
      },
      '&[aria-selected="true"]': {
        backgroundColor: '#ECEFF1',
        color: '#072D83',
      },
    },
  },
}));
